export default "/images/vendor/@material-design-icons/svg/outlined/arrow_back.svg?6c6d6aeb972d1ae6f7f040c891891aa9";